import React, { useState, useEffect } from "react"
import Grid from "@material-ui/core/Grid"
import Layout from "../components/layout"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import axios from "axios"
import { Waypoint } from "react-waypoint"
import Loading from "./loading"
import PremiumServices from "../components/Sidebar/PremiumServices"
import Seo from "../components/seo"
import Button from '@material-ui/core/Button';
import "../components/pageStyles.scss"

const TideTimesData = props => {
  const changetoTwentyFourHourTime = i => {
    if (i < 10) {
      i = "0" + i
    }
    return i
  }
  let weekendClass = ""
  if (props.weekEnd) weekendClass = "Weekend"

  var today = new Date(props.date)
  var todaycheck = new Date()
  todaycheck.setHours(0, 0, 0, 0)
  var timeNow = new Date()

  var h = changetoTwentyFourHourTime(timeNow.getHours())
  var m = changetoTwentyFourHourTime(timeNow.getMinutes())
  var filteredNow = h + ":" + m

  var timeArray = []
  timeArray.push(filteredNow)

  var ifNextTimeEntry
  if (
    today.getDate() === todaycheck.getDate() &&
    today.getMonth() === todaycheck.getMonth()
  ) {
    for (var i = 0; i < props.tideTimes.length; i++) {
      timeArray.push(props.tideTimes[i].time)

      timeArray.sort()
      var nextTime = timeArray.indexOf(filteredNow) + 1

      if (nextTime < 5) {
        if (typeof(props.tideTimes[`${nextTime - 1}`]) !== 'undefined' && props.tideTimes[`${nextTime - 1}`] != null) {
          ifNextTimeEntry = props.tideTimes[`${nextTime - 1}`].time
        }
      } else if (nextTime === 5) {
        if (typeof(props.tideTimes[3]) !== 'undefined' && props.tideTimes[3] != null) {
          ifNextTimeEntry = props.tideTimes[3].time
        }
      }
    }
  }
  return (
    <tr>
      <td className={"TidesDate " + weekendClass}>{props.formattedDate}</td>
      <td className={"TidesLowHigh " + weekendClass}>
        {props.tideTimes.map((result, index) => (
          <HighWater
            today={ifNextTimeEntry}
            currentTime={result.time}
            key={index}
            value={result.highLow}
            short={result.highLowShort}
          />
        ))}
      </td>
      <td className={"TidesTime " + weekendClass}>
        {props.tideTimes.map((result, index) => (
          <TideTimesItem
            today={ifNextTimeEntry}
            currentTime={result.time}
            key={index}
            value={result.time}
          />
        ))}
      </td>
      {props.mode ? (
        <td className={"TidesHeight " + weekendClass}>
          {props.tideTimes.map((result, index) => (
            <TideTimesItem
              today={ifNextTimeEntry}
              currentTime={result.time}
              key={index}
              value={result.height?.includes(".") ? result.height + "m" : result.height + ".0m" }
            />
          ))}
        </td>
      ) : (
        <td className={"TidesHeight " + weekendClass}>
          {props.tideTimes.map((result, index) => (
            <TideTimesItem
              today={ifNextTimeEntry}
              currentTime={result.time}
              key={index}
              value={result.heightinFeet + "ft"}
            />
          ))}
        </td>
      )}
    </tr>
  )
}

const TideTimesItem = props => {
  return props.today === props.currentTime ? (
    <span style={{ color: "#b60011" }}>
      {props.value}
      <br />
    </span>
  ) : (
    <span>
      {props.value}
      <br />
    </span>
  )
}

const HighWater = props => {
  return props.today === props.currentTime ? (
    <span>
      <span style={{ color: "#b60011" }} className="hidemobile">
        {props.value}
      </span>
      <span className="hiddendesktop">{props.short}</span>
    </span>
  ) : (
    <span>
      <span className="hidemobile">{props.value}</span>
      <span className="hiddendesktop">{props.short}</span>
    </span>
  )
}

const TideTimes = () => {
  const [url, setUrl] = useState(process.env.MET_TIDETIMES)
  const [displayButton, setDisplayButton] = useState(true)
  const [tides, setTides] = useState([])
  const [error, setError] = useState(false)
  const [hasMore, setHasMore] = useState(true)
  const [loading, setLoading] = useState(false)
  const [isLoadOnScroll, setisLoadOnScroll] = useState(false)
  const [counter, setCounter] = useState(0)
  const tableMenu = useMediaQuery("(min-width: 778px)")


  const fetchData = async () => {
    if (error || loading || !hasMore) return

    try {
      const result = await axios(url + "&page=" + counter.toString())
      const nextTide = result.data.map(tide => ({
        id: tide.id,
        date: tide.date,
        formattedDate: tide.formattedDate,
        weekEnd: tide.weekEnd,
        tideTimes: tide.tideTimes,
      }))
      if (url.length && url !== null) {
        setTides([...tides, ...nextTide])
      } else {
        setTides([])
      }
      setisLoadOnScroll(true)
      setHasMore(result.data.length === 30)

      if (counter===12)
        setHasMore(false)

      if (counter < 12)
        setCounter(counter + 1)
    } catch (error) {
      setError(true)
      setLoading(false)
      console.log(error)
    }
  }

  useEffect(() => {
    setError(false)
    setLoading(true)
    fetchData();
    setLoading(false)
  }, [url]) // eslint-disable-line


  const toggleFormat = () => {
    setDisplayButton(displayButton => !displayButton)
  }

  return (
    <React.Fragment>
      <Layout>
      <Seo title="Tide Times - St. Helier" description="Tide times for today and the week ahead for St Helier, Jersey" />
      <div className="forecastAutoMargin">
      <Grid item xs={12} sm={12} md={8} lg={8} className="menuTitle" style={{paddingLeft:0}}>
                  <h1>
                  St Helier tides
                  </h1>                  
      </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={8} lg={8}>
              {error ? (
                <div>
                  <p className="test" style={{ color: "#bf0d0d" }}>
                    Sorry, the tide times information is not available at the moment.
                    Check back later.
                  </p>
                  <div style={{textAlign:"center"}}><Button className="resendButton" onClick={() => setUrl(process.env.MET_TIDETIMES) }>Try again</Button></div>
                </div>
              ) : (
                <React.Fragment>
                  <div>
                    <p style={{marginTop:"0"}}>
                      All times are local. An hour has already been added for
                      BST where applicable
                    </p>
                    <p>
                      Tidal predictions for St Helier, Jersey, have been
                      computed by the{" "}
                      <a className="hover-link" href="http://noc.ac.uk/" target="_blank" rel="noreferrer">
                        National Oceanography Centre
                      </a>
                      : copyright reserved.
                    </p>
                    <div style={{ textAlign: "right" }}>
                      {displayButton === true ? (
                        <button onClick={toggleFormat} className="btn-default" style={{ marginRight: "0", marginBottom: "15px" }}>
                          Display height in feet
                        </button>
                      ) : ("")
                      }
                      {displayButton === false ? (
                        <button onClick={toggleFormat} className="btn-default" style={{ marginRight: "0", marginBottom: "15px" }}>
                          Display height in meters
                        </button>
                      ) : ("")
                      }
                    </div>

                    {tides.length !== 0 ? (
                      <table className="generalTableStyle" style={{ clear: "both" }}>
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>LW / HW</th>
                            <th className="rightTableHeadStyle" style={tableMenu ? { paddingLeft: "100px" } : {}}>
                              Local time
                            </th>
                            <th className="rightTableHeadStyle" style={tableMenu ? { paddingLeft: "100px" } : {}}>
                              Height
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {tides.map((result, index) => (
                            <TideTimesData mode={displayButton} key={index} {...result}/>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <Loading />
                    )}
                    <div style={{ display: "block", clear: "both" }}>
                      &nbsp;
                      <br />
                      <Waypoint onEnter={fetchData} />
                    </div>

                    {isLoadOnScroll && hasMore && <Loading />}
                    {!hasMore && (
                      <p style={{ color: "#bf0d0d" }}>End of tide data</p>
                    )}
                  </div>
                </React.Fragment>
              )}
            </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <PremiumServices/>
                </Grid>
          </Grid>
        </div>
      </Layout>
    </React.Fragment>
  )
}
export default TideTimes
